import { graphql } from '@/gql';
import type { GetActiveSubscriptionRefundDataQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getActiveSubscriptionRefundData = async ({
  callerId,
  refundType,
  refundAmount,
}: GetActiveSubscriptionRefundDataQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callerId,
      refundType,
      refundAmount,
    },
    query: graphql(`
      query GetActiveSubscriptionRefundData($callerId: String!, $refundType: String!, $refundAmount: Float) {
        getActiveSubscriptionRefundData(callerId: $callerId, refundType: $refundType, refundAmount: $refundAmount) {
          name
          refundAmount
          fullAmount
          refundDays
          totalPlanDays
          transactionId
          isActiveSubscription
          isCreditCharge
        }
      }
    `),
  });

  return response.data.getActiveSubscriptionRefundData ?? null;
};
